import { Component, input } from '@angular/core';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss'],
  standalone: false,
})
export class CommentComponent {
  readonly userName = input<string>(undefined);
  readonly dateCreated = input<string>(undefined);
  readonly text = input<string>(undefined);
  readonly mode = input<string>(undefined);

  constructor() {}
}
